import { render, staticRenderFns } from "./PeticionesView.vue?vue&type=template&id=5c84c32b&"
import script from "./PeticionesView.vue?vue&type=script&lang=js&"
export * from "./PeticionesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports